import { atom } from "recoil"

const onboardingProgress = atom({
  key: "onboarding_state",
  default: {
    activeStep: 0,
    association: {
      cardId: "",
      addressFull: "",
      address: "",
      city: "",
      state: "",
      country: "",
      email: "",
      image: "",
      location: {
        lat: "",
        lng: "",
      },
      name: "",
      phone: "",
      position: "",
      unit: "",
      url: "",
    },
    betaCode: "",
    inviteToken: "",
    invite: {},
    user: {
      id: "",
      email: "",
      firstName: "",
      lastName: "",
      password: "",
      confirmPassword: "",
      phone: "",
      position: "",
      unit: "",
    },
    verify: false,
    verified: false,
  },
})

export default onboardingProgress
